/**
 * paths.js
*/

import { Types } from './constants';


export const paths = {
  // records page
  records: {
    base:                   `/records`,
    basic:                  { path: `/:filterParams?`, pIndex: 0 },
    params:                 { path: `/:p1/:p2?/:filterParams?`, pIndex: 0 },
  },

  // training-drawer 
  training: {
    base:                   '/training-drawer',
    pattern:                '/:action/:type?/:id?',
    menu:                   { path: '/menu/:type/:id', pIndex: 0, },
    addExercise:            { path: '/add-exercise/event/:eventId', pIndex: 2 },
    editEvent:              { path: '/edit/event/:eventId', pIndex: 1 },
    editExercise:           { path: '/edit/exercise/:exerciseId', pIndex: 2 },
    editAnswer:             { path: '/edit/exercise/:exerciseId/answer/:answerId', pIndex: 3},
    viewEvent:              { path: '/view/event/:eventId', pIndex: 1.1 },
    viewExercise:           { path: '/view/exercise/:exerciseId', pIndex: 2.1 },
    viewAnswer:             { path: '/view/exercise/:exerciseId/answer/:answerId', pIndex: 3.1 },
    quickTraining:          { path: '/quick-training', pIndex: 0 },
    // supervisor-special
    viewHandlerAnswers:     { path: '/view/exercise/:exerciseId/handler/:handlerId', pIndex: 3.1 },
    viewHandlerAnswer:      { path: '/view/exercise/:exerciseId/handler/:handlerId/answer/:answerId', pIndex: 3.1 },
    // wizard-pattern
    wizardPattern:          '/wz/:step/:action/:type/:id',
    wizardStart:            { path: '/wz/0/init/event/:eventId/', pIndex: -3 },
    wizardCreateEvent:      { path: '/wz/1/create/event/:eventId', pIndex: -3 },
    wizardSelectEvent:      { path: '/wz/1/select/event/:eventId', pIndex: -3 },
    wizardEditEvent:        { path: '/wz/1/edit/event/:eventId', pIndex: -3 },
    wizardAddExercise:      { path: '/wz/2/create/event/:eventId', pIndex: -2 },
    wizardEditExercise:     { path: '/wz/2/edit/exercise/:exerciseId', pIndex: -2 },
    wizardAddAnswer:        { path: '/wz/3/create/exercise/:exerciseId/answer/:answerId', pIndex: -1 },
    wizardCompleteMenu:     { path: '/wz/4/view/event/:eventId/menu', pIndex: 0 },
    wizardCompleteEvent:    { path: '/wz/4/view/event/:eventId', pIndex: 0 },
    wizardCompleteExercise: { path: '/wz/4/view/exercise/:exerciseId', pIndex: 0 },
  },
  
  // deployment-drawer
  deployment: {
    base:                   '/deployment-drawer',
    pattern:                '/:deploymentId/:viewSectionId?/(edit)?/:editSectionId?',
    view:                   { path: '/:deploymentId/:viewSectionId?', pIndex: 0},
    edit:                   { path: '/:deploymentId/:viewSectionId?/edit/:editSectionId', pIndex: 0},
  },

  // class-drawer
  class: {
    base:                   '/class-drawer',
    pattern:                '/:action/:type?/:id?',
    view:                   { path: '/view/class/:classId', pIndex: 0 },
    edit:                   { path: '/edit/class/:classId', pIndex: 0 },
  },

  // vet-visit-drawer
  vetVisit: {
    base: '/vet-visit-drawer',
    pattern: '/:action/:type?/:id?',
    view: { path: '/view/vet-visit/:vetVisitId', pIndex: 0 },
    edit: { path: '/edit/vet-visit/:vetVisitId', pIndex: 0 },
  },

  // groups-drawers
  groups: {
    base:                   '/groups',
    pattern:                '/:type/:id?',
    typeMenu:               { path: '/:type', pIndex: 0, },
    managerGroup:           { path: '/managers/:managerId/:roleId', pIndex: 1 },
    trainingGroup:          { path: '/training/:id', pIndex: 1 },
    connections:            { path: '/connections', pIndex: 1 },
  },
};


// RECORDS PAGE URL MATCHING
// [\\w]+ looks for 1 or more alphanumeric chars
// = followed by an equals character
// [\\w=;,\\-\\[\\]]+ followed by 1 or more of any alphanumeric = ; , % | - [ ] +
const filterParamsMatch = ':filterParamsString([\\w]+=[\\w=;,%+|\\-\\[\\]]+)?';
const paginationMatch = '(page)?/:pageNum(\\d+)?';
const modeOptions = `${Types.FilterMode.values().join('|')}`;
export const recordListPaths = [
  `/records/:filterMode(${modeOptions})/:filterOption([\\w|-]+)?/${filterParamsMatch}/${paginationMatch}`,
  `/records/${filterParamsMatch}/${paginationMatch}`,
];


export function makeLocation(basePath, sectionName, itemName, params, currentLocation, queryParams) {
  const pathItem = paths[sectionName][itemName];
  let pathEnd = pathItem.path;

  // replace path vars with given params using regex
  // replace includes ':' prefix and possible '?' suffix
  for (let key in params) {
    pathEnd = pathEnd.replace(new RegExp(`:${key}\\??`), params[key]);
  }

  // remove any unreplaced optional params
  pathEnd = pathEnd.replace(/\/:[a-z0-9]+\?/i, '');

  // trailing slash causes probs
  if (pathEnd.endsWith('/')) {
    pathEnd = pathEnd.slice(0, -1);
  }

  return {
    pathname: 
      `${basePath || ''}${paths[sectionName].base}${pathEnd}`
      + `${queryParams ? '/?' + new URLSearchParams(queryParams).toString() : ''}`,
    state: {
      prevLocation: currentLocation,
      transition: { pIndex: pathItem.pIndex }
    }
  };
}


export function getPaginationPaths(basePath, pageNum, pageMax, queryParams) {
  if (basePath.includes('/page/')) {
    basePath = basePath.replace(`/page/${pageNum}`, '');
  }

  return {
    prev: pageNum > 1 
      ? `${basePath}/page/${pageNum - 1}${queryParams}`
      : null,
    next: pageNum < pageMax 
      ? `${basePath}/page/${pageNum + 1}${queryParams}`
      : null
  };
}


export function makeDeploymentSectionPath(sectionType, record) {
  if (sectionType === Types.DeploymentSection.PATROL && record) {
    return `${sectionType}-${record.type}-${record.id}`;
  } else {
    return `${sectionType}`;
  }
}